__turbopack_context__.v({
  "root": "_2MnQyG_root",
});
